import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OpportunitiesService } from '../services/opportunities.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { DefineHLDInsuranceComponent } from '../dialogs/define-hld-insurance/define-hld-insurance.component';
import { WhatIsHLDInsuranceComponent } from '../dialogs/what-is-hld-insurance/what-is-hld-insurance.component';
import { OpportunitySnapshotsService } from '../services/opportunity-snapshots.service';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  errorOverride: boolean = false;
  paymentVisible: boolean = false;
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted)) || !!this.errorOverride;
  }
}

@Component({
  selector: 'app-landing-page',
  standalone: false,
  templateUrl: './landing-page.component.html',
  styleUrl: '../../assets/css/HighLimits.css'
})
export class LandingPageComponent {
  sponsorToken: string = '';
  errorMessage: string = '';
  snackBarConfig: MatSnackBarConfig = {
    horizontalPosition: 'center',
    verticalPosition: 'top',
    duration: 5000
  };
  matcher: MyErrorStateMatcher = new MyErrorStateMatcher();

  readonly dialog = inject(MatDialog);

  constructor(private _router: Router,
    private _opportunitiesService: OpportunitiesService,
    private _snackBar: MatSnackBar,
    private _courselConfig: NgbCarouselConfig,
    private _oss: OpportunitySnapshotsService) {
    this._courselConfig.interval = 5000;
    this._courselConfig.wrap = true;
  }

  ngOnInit() {
    localStorage.clear();
    this._oss.clearAllAdditionalBenefits();
  }

  findApplication() {
    this._router.navigate(['/application']);
  }

  defineHLD() {
    let dialogRef = this.dialog.open(DefineHLDInsuranceComponent, {
      disableClose: true,
    });

    dialogRef.updatePosition({ top: '200px' });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  whatIsHLD() {
    let dialogRef = this.dialog.open(WhatIsHLDInsuranceComponent, {
      disableClose: true,
    });

    dialogRef.updatePosition({ top: '200px' });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  openFAQ() {
    window.open('https://mgisdev.blob.core.windows.net/admin-documents/High%20Limit%20Enrollments/High%20Limits%20-%20FAQ.pdf', '_blank');
  }
}